export default __webpack_public_path__ + "static/media/collapse-sider-icon.6e1faad0.svg";